module.exports = __webpack_public_path__ + "img/hr-pumpjack-horsehead-shadow.949c2b41.png";